exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".c-header-cell_sort-indicator{float:right}.c-header-cell_sort-indicator>svg{display:block}.c-header-cell_sort-indicator>svg.blue{color:#112363}.c-header-cell_sort-indicator>svg.blue-medium{color:#a0a7c1}.c-header-cell_sort-indicator>svg:first-child{margin-bottom:-7px}", ""]);

// exports
